if (!customElements.get('astrobrew-assortment')) {
  customElements.define('astrobrew-assortment', class extends HTMLElement {
    connectedCallback() {
      this.cards = [...this.querySelectorAll('[data-category]')];
      this.buttons = [...this.querySelectorAll('[data-filter]')];
      this.buttons.forEach(button => {
        button.querySelector('[data-count]').textContent = this.cards.filter(card =>
          button.dataset.filter === 'All' || card.dataset.category === button.dataset.filter).length;
      });
      this.onFilter = event => {
        const button = event.target.closest('[data-filter]');
        if (button && this.contains(button)) this.filter(button.dataset.filter);
      };
      this.addEventListener('click', this.onFilter);
      this.querySelector('[data-toolbar]').hidden = false;
      this.filter('All');
    }
    disconnectedCallback() { this.removeEventListener('click', this.onFilter); }
    filter(category) {
      let visible = 0;
      this.cards.forEach(card => {
        card.hidden = category !== 'All' && category !== card.dataset.category;
        if (!card.hidden) visible++;
      });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === category)));
      this.querySelector('[data-results]').textContent = `Showing ${visible} of ${this.cards.length} products`;
      this.querySelector('[data-empty]').hidden = visible !== 0;
    }
  });
}
